// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SXR4","title":"styles_title__1E25g"};